export default __webpack_public_path__ + "static/media/hero-background.ad101358.png";